import type { paths } from "./api-types";

export type CheckoutParticipant = NonNullable<
  paths["/api/public/checkouts/{checkoutId}/participants"]["get"]["responses"][200]["content"]["application/json"]["participants"]
>[number];

export type ParticipantConsentPatchBody = NonNullable<
  paths["/api/public/checkouts/{checkoutId}/participants/consent"]["patch"]["requestBody"]
>["content"]["application/json"];

export function getParticipantKey(participant: {
  userId: string | null;
  firstName: string;
  lastName: string;
}): string {
  return (
    participant.userId ??
    `${participant.firstName.trim().toLowerCase()}-${participant.lastName.trim().toLowerCase()}`
  );
}
